module.exports = __webpack_public_path__ + "images/upgrade-trial.f0f5a806bd4a8e70d59a4b8505df63f6.jpg";